import { types } from 'mobx-state-tree';
import { BaseModel, Bits, wemogyTypes } from '@wemogy/reactbase';
var RoleSubType = types
    .model({
    name: types.optional(types.string, ''),
    tenantId: types.string,
    levelRoles: types.optional(types.array(types.array(wemogyTypes.bits)), [
        [Bits.emptyValue, Bits.emptyValue, Bits.emptyValue, Bits.emptyValue]
    ])
})
    .named('RoleSubType')
    .views(function (self) { return ({
    getLevelRole: function (pathIndex, levelIndex) {
        return self.levelRoles[pathIndex][levelIndex];
    }
}); })
    .actions(function (self) { return ({
    setName: function (name) {
        self.name = name;
    },
    togglePermissionFlag: function (permissionLevel, permissionFlag) {
        this.updateLevelRolePermissionFlag(permissionLevel, function (levelRole) {
            var isEnabled = levelRole.hasFlag(permissionFlag);
            if (isEnabled) {
                levelRole.removeFlag(permissionFlag);
                var permissionFlagDependencies = Object.keys(permissionLevel.permissionDependencies)
                    .filter(function (key) {
                    var dependenciesOfKey = permissionLevel.permissionDependencies[key];
                    return dependenciesOfKey.includes(permissionFlag);
                })
                    .map(function (x) { return parseInt(x); });
                levelRole.removeFlags(permissionFlagDependencies);
            }
            else {
                levelRole.setFlag(permissionFlag);
                var dependencies = permissionLevel.permissionDependencies[permissionFlag];
                if (dependencies) {
                    levelRole.setFlags(dependencies);
                }
            }
        });
    },
    setPermissionFlag: function (permissionLevel, permissionFlag) {
        this.updateLevelRolePermissionFlag(permissionLevel, function (levelRole) {
            var isEnabled = levelRole.hasFlag(permissionFlag);
            if (isEnabled) {
                return;
            }
            levelRole.setFlag(permissionFlag);
            var dependencies = permissionLevel.permissionDependencies[permissionFlag];
            if (dependencies) {
                levelRole.setFlags(dependencies);
            }
        });
    },
    updateLevelRolePermissionFlag: function (permissionLevel, updaterCallback) {
        var levelRole = self.getLevelRole(permissionLevel.pathIndex, permissionLevel.levelIndex);
        updaterCallback(levelRole);
        self.levelRoles[permissionLevel.pathIndex][permissionLevel.levelIndex] = new Bits(levelRole.toString());
    }
}); });
var Role = types.compose(BaseModel, RoleSubType).named('Role');
export default Role;
//# sourceMappingURL=Role.js.map